import React from 'react';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { SideNavigation } from '@bingads-webui-fluent-component/navigation';


const useStyles = makeStyles({
  container: {
    width: '85px',
    flexShrink: 0,
  },
  tab: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '& span.side-navigation-item-text': {
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical',
      ...shorthands.overflow('hidden'),
      wordBreak: 'break-word',
      hyphens: 'auto',
    },
    '&.side-navigation-item-button:hover, &.side-navigation-item-button:focus': {
      '& > span': { color: tokens.colorNeutralForeground3BrandHover },
    },
  },
});

export const Navigation = ({ items }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <SideNavigation
        items={items}
        mode={2}
        className={classes.tab}
        reserveSelectedTabSpace={false}
        config={{ selectionMode: 2 }}
      />
    </div>
  );
};
